export const REDUCER_NAME="instagramAdsSlice";

// Payload for creating an ad
export interface IInstagramAdCreateDTO {
  name: string;
  status: "ACTIVE" | "PAUSED" | "ARCHIVED" | "DELETED";
  adset_id: string;
  creative_id: string;
}

// Data returned by backend / Instagram API
export interface IInstagramAdDTO {
  id: string;
  name: string;
  status: "ACTIVE" | "PAUSED" | "ARCHIVED" | "DELETED";
  created_time: string;

  adset: {
    id: string;
  };

  campaign: {
    id: string;
  };

  creative: {
    id: string;
  };
}

// Redux state
export interface IInstagramAdsState {
  instagramAdsList: IInstagramAdDTO[] | null;
  isLoading: boolean;
  errorMessage: string | null;
}
